/**
 * Created by ah on 17/01/17.
 */

export const Keys = {
    // Id field of all entities
    ID:'id',
    NAME:'name',

    // the main collections of the individual store slices:

    Assignee: {
        FIRST_NAME:'firstName',
        LAST_NAME:'lastName',
        GROUPS:'groups',
        IN_WORK_SESSION:'inWorkSession',
        ITEMS:'itemIds',
        QC_ITEMS:'qcItemIds',
        ACTIVE:'isActive',
    },
    Item: {
        IN_WORK_SESSION:'inWorkSession',
        PUBLISH_DATE:'publishDate',
        VIEWS:'views',
        DISPLAYS:'displays',
        CATEGORY:'category',
        CUSTOMER:'customer',
        PREVIEW_URL:'previewUrl',
        ASSIGNEE_ID:'assigneeId',
        QC_ASSIGNEE_ID:'qcAssigneeId',
        HIDDEN:'hidden',
        VIEW_COUNT:'viewCount',
        DISPLAY_COUNT:'displayCount',
        GHOST_COUNT:'ghostCount',
        COMPLETION_SCORE:'completionScore',
        DIFFICULTY_TAGS:'difficultyTags',
        DIFFICULTY_SCORE:'difficultyScore',

    },
    CurrentWorkSession: {
        ASSIGNEES:'assigneeIds',
        ITEMS:'itemIds',
    },
    WorkSessions: {
        MANAGED_BY:'managedBy',
        STARTED:'started',
        ENDED:'ended',
        NAME:'name',
        TEMPLATE_ID:'templateId',
    },

    MutationType:{
        ASSIGNEE:'assignee',
        ITEM:'item',
        NONE:'none', // used to signal no modification type
    },
    EditorIds:{
      ASSIGNEE_PAGE:'assigneePage',
      ITEMS_PAGE:'itemsPage',
      ADD_ITEMS_PAGE:'addItemsPage',
      OVERVIEW_PAGE:'overviewPage',
    },

    StoreSliceData: {
        CURRENT_WORK_SESSION:'currentWorkSession',
        WORK_SESSIONS:'workSessions',
        WORK_SESSION_TEMPLATES:'workSessionTemplates',
        ASSIGNEES:'assignees',
        GROUPS:'groups',
        ITEMS:'items',
        ACCOUNT:'account',
    },

    StoreSliceMeta : {
        LAST_LOAD_SUCCESS:'lastLoadSuccess',
        LAST_SAVE_SUCCESS:'lastSaveSuccess',
        UPDATE_TIME:'updateTime',
        LOADING:'loading',
        LOADING_FAILED:'loadingFailed',
        SAVING:'saving',
        SAVING_FAILED:'savingFailed',
    },

    // General store state keys

    LoginStateMeta: {
        LOGIN_TIMESTAMP:'loginTimestamp',
        LOGGED_IN:'loggedIn',
        LOGIN_PROGRESS:'loginProgress',
        LOGIN_FAILED:'loginFailed',
        LOGIN_ABORTED:'loginAborted',
        ERROR_MESSAGE:'errorMessage',
    }


};




// WEBPACK FOOTER //
// ./src/model/constants/keys.js